import { render, staticRenderFns } from "./RecipeSearch.vue?vue&type=template&id=71e86ff5&scoped=true"
import script from "./RecipeSearch.vue?vue&type=script&lang=js"
export * from "./RecipeSearch.vue?vue&type=script&lang=js"
import style0 from "./RecipeSearch.vue?vue&type=style&index=0&id=71e86ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e86ff5",
  null
  
)

export default component.exports